module.exports = __webpack_public_path__ + "img/img-badge-006-off@3x.97fd5bff.png";